import React from 'react';
import styles from './index.css';
import IconButton from '@material-ui/core/IconButton';
import {Link} from 'react-router-dom';
import {HomeIcon} from '../../Icon';
import * as PropTypes from 'prop-types';
import {FormattedMessage, useIntl} from 'react-intl';

export const CreateEnvelopeHeader = ({disabled}) => {
    const intl = useIntl();
    return (
        <div className={styles.pageHeader}>
            <IconButton
                aria-label="Go to Dashboard"
                color="primary"
                component={Link}
                disabled={disabled}
                size="small"
                style={{backgroundColor: '#f7f7f7', border: '1px solid'}}
                title={intl.formatMessage({id: 'labels.BACK_TO_DASHBOARD'})}
                to="/e-sign"
            >
                <HomeIcon/>
            </IconButton>
            <h3>
                <FormattedMessage id={'labels.CREATE_ENVELOPE'}/>
            </h3>
        </div>
    );
}

CreateEnvelopeHeader.propTypes = {
    disabled: PropTypes.bool
}
